// eslint-disable-next-line import/no-unresolved
import { navigate } from '@reach/router';
import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from '@powdr/components';
import { useNavigationHistory } from '@powdr/hooks';
import {
  isBuildTime,
} from '@powdr/utils';

import {
  PageBackButton,
} from './styles';

export const BackButton = ({
  backButtonLink = null,
}) => {
  if (isBuildTime()) return null;
  const { isDirectLink } = useNavigationHistory();

  const handleButtonClick = () => {
    if (isDirectLink && backButtonLink) {
      navigate(backButtonLink);
    } else {
      window.history.back();
    }
  };

  return (
    <PageBackButton className="levels-back-button">
      <button type="button" onClick={handleButtonClick}>
        Back
        <Icon className="levels-back-icon" name="ui-back-arrow" width="20" />
      </button>
    </PageBackButton>
  );
};

BackButton.propTypes = {
  backButtonLink: PropTypes.string,
};
